import { isAfter } from 'date-fns';

import { convertToSlug } from '../../utils';

import type { IEvent } from '../../types';

export const filterByShortcode =
	(filters: string[], property: string) =>
	(event: IEvent): boolean => {
		if (!Array.isArray(filters) || filters.length === 0) return true;
		if (!Array.isArray(event[property])) return false;
		return event[property].some((filter) => filters.includes(filter));
	};

export const filterByShortcodeVenue =
	(venue?: string) =>
	(event: IEvent): boolean => {
		if (!venue || !event.venue) return true;

		// Check if it's a comma-separated list of IDs
		if (/^\d+(,\d+)*$/.test(venue.trim())) {
			const venueIds = venue
				.split(',')
				.map((id) => parseInt(id.trim(), 10))
				.filter((id) => !isNaN(id));

			return venueIds.includes(event.venue.id);
		}

		// Check if it's a single numeric ID
		const parsedVenue = parseInt(venue.trim(), 10);
		if (!isNaN(parsedVenue)) {
			return event.venue.id === parsedVenue;
		}

		// Treat as slug
		const venueSlug = convertToSlug(venue);
		return convertToSlug(event.venue.name) === venueSlug;
	};

export const filterOutExpiredEvents =
	(includeExpired: boolean | undefined) =>
	(event: IEvent): boolean => {
		if (includeExpired === false) {
			if (!(event.actualEnd instanceof Date)) {
				console.warn('Missing actualEnd for event:', event.UID);
				return true;
			}
			const now = new Date();
			return isAfter(event.actualEnd, now);
		}
		return true;
	};
